import * as React from 'react';
export const codeSvg = React.forwardRef(function codeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.166 1.141a.8.8 0 0 1 1.568.317l-1.9 9.4a.8.8 0 0 1-1.568-.317l1.9-9.4ZM3.698 2.174A.8.8 0 0 1 3.826 3.3L1.667 6.008l1.671 2.21a.8.8 0 1 1-1.276.965L.162 6.67A.8.8 0 0 1 0 6.188v-.375a.8.8 0 0 1 .174-.499l2.4-3.012a.8.8 0 0 1 1.124-.128Zm5.119.488a.8.8 0 0 1 1.121.155l1.9 2.513a.8.8 0 0 1 .162.482v.375a.8.8 0 0 1-.174.499l-2.4 3.012a.8.8 0 0 1-1.252-.996l2.159-2.71-1.671-2.21a.8.8 0 0 1 .155-1.12Z',
    }),
  );
});
codeSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var code = {
  category: 'icon',
  colorable: true,
  name: 'code',
  svg: codeSvg,
};
